import { BoundTextField, BoundTextFieldProps, Only, TextFieldXss } from "@homebound/beam";
import { Observer } from "mobx-react";
import { ObjectState } from "src/utils/formState";
import { AiFieldProposalFormValue } from "./utils/aiFieldProposalForm";
import { parseAiString, pendingProposedValue, resolveAiProposalStatus } from "./utils/bindAiProposal";

export type BoundAiTextFieldProps<X> = Omit<BoundTextFieldProps<X>, "proposedValue"> & {
  aiProposal?: ObjectState<AiFieldProposalFormValue>;
};

export function BoundAiTextField<X extends Only<TextFieldXss, X>>(props: BoundAiTextFieldProps<X>) {
  const { field, aiProposal, onChange, ...others } = props;
  // Observer wrapper needed for `aiProposal.status` / `fieldValue` so the pending proposal stays in
  // sync. `BoundTextField` has its own `Observer`, but that only covers the reads inside its render —
  // `pendingProposedValue` runs out here, in the caller's, so it needs its own reactive scope.
  return (
    <Observer>
      {() => (
        <BoundTextField
          field={field}
          proposedValue={pendingProposedValue(aiProposal, parseAiString)}
          onChange={(value) => {
            field.set(value);
            resolveAiProposalStatus(aiProposal, parseAiString, value);
            onChange?.(value);
          }}
          {...others}
        />
      )}
    </Observer>
  );
}
